const { extractCapturingGroup } = require('../../../../utilities/regex');
const checkIfCurrentPage = require('../../helpers/checkIfCurrentPage');

const categoryListIdFromUrlRegex = /\/[a-z]{2}-[a-z]{2}(\/.*)/iu;

/**
 * Gets the H1.page-title text formatted as a category list id
 * @example " Back to work " -> back_to_work
 * @example "Adolfo Domínguez | Web Oficial" -> adolfo_domínguez_|_web_oficial
 * @return {string} category list id based on main title
 */
function getCurrentCategoryListIdFromPageTitle() {
    let categoryListId;
    let $pageTitle = $('.page-title');

    if ($pageTitle.length === 0) return categoryListId;

    categoryListId = $pageTitle
        .text()
        .toLowerCase()
        .trim()
        .replace(/[ -]+/g, '_');

    return categoryListId;
}

/**
 * Get the current category list identifier from DOM
 * @returns {string} category identifier for datalayer list
 */
function getCurrentCategoryListIdFromDOM() {
    let categoryListId;
    // Use current category
    if (
        checkIfCurrentPage().isSearchPage
    ) {
        // Get the ID of the current category
        const currentCategoryId = document.querySelector('.js-current-category')
            ?.dataset.category;

        // Get the menu item for the current category
        const menuItemWithDatalayerInfo = document.querySelector(
            `[data-category="${currentCategoryId}"][data-category-list]`
        );

        if (menuItemWithDatalayerInfo) {
            if (menuItemWithDatalayerInfo.matches('.floating-plp-navigation-item__link')) {
                // Try to get the the categoryListId from the href of the link
                categoryListId = extractCapturingGroup(
                    menuItemWithDatalayerInfo.href,
                    categoryListIdFromUrlRegex
                );
            } else {
                categoryListId = menuItemWithDatalayerInfo.getAttribute('data-category-list');
            }
        }

        if (!categoryListId) {
            /* When the category is not visible in the main menu...
             * Use the page title to build a list ID as fallback
             */
            categoryListId = getCurrentCategoryListIdFromPageTitle();
        }
    }
    return categoryListId;
}

module.exports = {
    getCurrentCategoryListIdFromDOM
};
